/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const TextParagraphIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Text Paragraph',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M13.4 4c-4.5 0-8.919 3.623-9.354 8.105A9.009 9.009 0 0 0 13 22c1.05 0 3-.075 3-.075V33.5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V7h6v26.5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V5a1 1 0 0 0-1-1Z"
    />
  </svg>`;
};
